import * as React from 'react';
import { ViewMessageRates } from './ViewMessageRates';
import { Calculator } from './Calculator';

export const BalanceCalculator = () => (
  <div id="balance-calculator">
    <p className="header">See how far your balance will go</p>
    <p className="subtitle">
      Calculate how many SMS, MMS, and minutes you can get.
      &nbsp;
      <ViewMessageRates />
    </p>
    <Calculator />
  </div>
);
